exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-input-group[data-v-91488cce]{width:100%;display:flex;align-items:center}.fts-input-group .input-group-prepend[data-v-91488cce]{display:flex;align-items:center;padding-right:.375rem}.fts-input-group .input-group-append[data-v-91488cce]{display:flex;align-items:center;padding-left:.375rem}.fts-input-group.input-group--items-start[data-v-91488cce]{align-items:flex-start}.fts-input-group.input-group--items-end[data-v-91488cce]{align-items:flex-end}", ""]);

// exports
